import type { ReactNode } from 'react';
import { useId } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import InfoIcon from './InfoIcon';

type CounterCardProps = {
  title: string;
  hint: string;
  children: ReactNode;
};

// The tooltip's own edge must clear the trigger: an arrow overlapping it would take the pointer
// off the button, hiding the tooltip and putting the pointer back on the button, on and on.
const HINT_POPPER_CONFIG = { modifiers: [{ name: 'offset', options: { offset: [0, 8] } }] };

function CounterCard({ title, hint, children }: CounterCardProps) {
  const titleId = useId();
  const hintId = useId();

  return (
    <section className="diagnostics-counter-card" aria-labelledby={titleId}>
      <div className="diagnostics-counter-head">
        <h2 id={titleId} className="diagnostics-counter-title">
          {title}
        </h2>
        {/* React-bootstrap's default Fade waits for a `transitionend` jsdom never fires. */}
        <OverlayTrigger
          placement="top"
          transition={false}
          popperConfig={HINT_POPPER_CONFIG}
          overlay={
            <Tooltip id={hintId} className="diagnostics-counter-tooltip">
              {hint}
            </Tooltip>
          }
        >
          <button type="button" className="diagnostics-counter-hint" aria-label={`About ${title.toLowerCase()}`}>
            <InfoIcon />
          </button>
        </OverlayTrigger>
      </div>
      {children}
    </section>
  );
}

export default CounterCard;
